import { FC, Suspense } from 'react';
import { Layout as BaseLayout, ConfigProvider } from 'antd';
import { Outlet } from 'react-router';

export default function AdminLayout() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#1c8271',
        },
      }}
    >
      <BaseLayout
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#f7f7f7',
        }}
      >
        <BaseLayout.Content style={{ flex: 1 }}>
          <Suspense>
            <Outlet />
          </Suspense>
        </BaseLayout.Content>
      </BaseLayout>
    </ConfigProvider>
  );
}
